import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';

import { moment } from '../lib/moment';
import { DateRangeType } from '../model/time';

const t = i18n(keyset);

interface DateRange {
    title: string;
    getRange: () => { from: moment.Moment; to: moment.Moment };
}

export const monitoringDatepickerRanges: Record<DateRangeType, DateRange> = {
    hour: {
        title: t('date-hour'),
        getRange: () => {
            const now = moment();

            return {
                from: now.clone().add('-1', 'hours'),
                to: now,
            };
        },
    },
    day: {
        title: t('date-day'),
        getRange: () => {
            const now = moment();

            return {
                from: now.clone().add('-1', 'days'),
                to: now,
            };
        },
    },
    week: {
        title: t('date-week'),
        getRange: () => {
            const now = moment();

            return {
                from: now.clone().add('-1', 'weeks'),
                to: now,
            };
        },
    },
    month: {
        title: t('date-month'),
        getRange: () => {
            const now = moment();

            return {
                from: now.clone().add('-1', 'months'),
                to: now,
            };
        },
    },
    half_year: {
        title: t('date-half-year'),
        getRange: () => {
            const now = moment();

            return {
                from: now.clone().add('-6', 'months'),
                to: now,
            };
        },
    },
};

export const isLessThanHalfYear = (from: moment.Moment, to: moment.Moment) => {
    const date = from.clone().add(6, 'months');

    return to.isBetween(from, date);
};
